import api from '../../../services/api'

export default {
  //fetchLocationsGrid fetchLocationsGrid({ pageSize: this.pageSize, pageNumber: this.pageNumber })
  async fetchLocationsGrid({ commit }, { pageSize, pageNumber }) {
    try {
      const response = await api.get(`api/locations/GetLocationsGrid?pageSize=${pageSize}&pageNumber=${pageNumber}`)
      commit('SET_LOCATIONS_GRID', {
        locations: response.data.result,
        pagesCount: response.data.pagesCount,
        totalCountData: response.data.totalCountData
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async fetchLocations({ commit }) {
    try {
      const response = await api.get('api/locations/GetLocations')
      commit('SET_LOCATIONS', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async fetchLocation({ commit }, id) {
    try {
      const response = await api.get(`api/locations/GetLocation/${id}`)
      commit('SET_LOCATION', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async createLocation({ commit }, location) {
    try {
      const response = await api.post('api/locations/CreateLocation', location)
      commit('ADD_LOCATION', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async updateLocation({ commit }, location) {
    try {
      const response = await api.put(`api/locations/UpdateLocation/${location.id}`, location)
      commit('UPDATE_LOCATION', response.data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async deleteLocation({ commit }, id) {
    try {
      await api.delete(`api/locations/DeleteLocation/${id}`)
      commit('DELETE_LOCATION', id)
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
